module.exports = __webpack_public_path__ + "static/media/ic_account.a1d971db.png";